import * as Events from './Events';
import * as Bus from './Bus';
import { GetVerifactuIssuesRequest, GetVerifactuIssuesResponse } from 'core/api';

const TIME_BETWEEN_CHECKS = 60 * 1000;

const process = Bus.buildProcessFn('/bus/');


export type Status = 'OK' | 'INVALID_STATUS' | 'ERROR';

let status: Status = 'OK';
let config: Nullable<Config> = null;

const handleResponse = async (response: GetVerifactuIssuesResponse) => {
	status = response.HasVerifactuInvoiceIssues ? 'INVALID_STATUS' : 'OK';
	void Events.raise('verifactu:issue-updated', { status });
};

export function getStatus(): Status {
	return status;
}

type Config = {
	AdminHttpPort: number,
	AdminHttpUseSsl: boolean,
	HubUrl: string
};

export function getVerifactuViewerURL(): string {
	if (!config)
		return '';

	const verifactuPath = 'tools/verifactu/chain-viewer';
	return config.HubUrl
		? `${config.HubUrl}/#/${verifactuPath}`
		: `http${config.AdminHttpUseSsl ? 's' : ''}://${document.location.hostname}:${config.AdminHttpPort}/#/${verifactuPath}`;
}

export async function startChecking(configuration: Nullable<Config> = null): Promise<void> {
	config = configuration;
	await check();
}

let intervalId: Nullable<NodeJS.Timeout> = null;

function startInterval() {
	intervalId = setInterval(async () => {
		await check();
	}, TIME_BETWEEN_CHECKS);
}

function stopInterval() {
	if (intervalId)
		clearInterval(intervalId);
}

async function check() {

	try {
		stopInterval();
		const request = new GetVerifactuIssuesRequest();
		await process(request, handleResponse);

	}
	catch {
		void Events.raise('verifactu:issue-updated', { status: 'ERROR' });
		status = 'ERROR';
	}
	finally {
		startInterval();
	}
}
